import classNames from 'classnames';
import loadingGif from './loadingAnimation.gif';

export function LoadingAnimation({
    className,
    ...props
}: Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src'>) {
    return (
        <img
            src={loadingGif}
            alt="Loading..."
            className={classNames('mx-auto my-0 block w-[200px]', className)}
            {...props}
        />
    );
}
